import React, {FC, useEffect} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'
import Link from 'next/link'

import PaystubTemplatePreview from 'components/blocks/forms/FormPayStubNew/PaystubTemplatePreview'
import {TemplatePagination} from 'src/components/blocks/forms/FormPayStubNew/PayStubChooseTemplateNew/TemplatePagination'
import MobxCheckbox from 'src/components/elements/fields/MobxCheckbox'
import MessageBlock from 'src/components/elements/MessageBlock'
import {posthogTrack} from 'src/utils'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsPayStubLastStep.module.scss'
const cx = cn.bind(s)

interface IFieldsPayStubLastStepProps {
	className?: string
	errorMessage?: string
	activeTemplate: IPayStubTemplates
}

const FieldsPayStubLastStep: FC<IFieldsPayStubLastStepProps> = ({
	className,
	activeTemplate,
	errorMessage,
}) => {
	const payStubStore = usePayStubStore()
	const paystubsCount = Number(payStubStore.payStubsNumber)

	useEffect(() => {
		posthogTrack(`[PAYSTUB] Step 6 started`)
	}, [])

	return (
		<>
			<div className={cx('preview', 'preview--mobile')}>
				<div className={cx('preview__template')}>
					<PaystubTemplatePreview activeTemplate={activeTemplate} />
				</div>

				{paystubsCount > 1 ? (
					<div className={cx('preview__pagination')}>
						<TemplatePagination
							payStubs={paystubsCount}
							setActiveDataTemplate={payStubStore.setActiveDataTemplate}
							activeDataTemplate={payStubStore.activeDataTemplate}
						/>
					</div>
				) : null}
			</div>

			<MobxCheckbox
				classNameWrapper={cx('finish--privacy')}
				required
				name="privacy"
				store={payStubStore}
				value={payStubStore?.privacy}
				label="I agree that I will not use this site for any illegal purposes"
			/>

			<MobxCheckbox
				classNameWrapper={cx('finish--privacy')}
				required
				name="terms"
				store={payStubStore}
				value={payStubStore?.terms}
				label={
					<>
						Please accept our <Link href="/terms">Terms of Use</Link> and{' '}
						<Link href="/privacy-policy">Privacy Policy</Link>
					</>
				}
			/>

			{(errorMessage || payStubStore.errorMessage) && (
				<div className={cx('finish__error')}>
					<MessageBlock type="error" message={errorMessage || payStubStore.errorMessage} />
				</div>
			)}
		</>
	)
}

FieldsPayStubLastStep.displayName = 'FieldsPayStubLastStep'

export default observer(FieldsPayStubLastStep)
